import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/home/")({
  component: RouteComponent,
  beforeLoad: async () => {
    throw redirect({
      to: "/signup",
    });
  },
});

function RouteComponent() {
  return <div>Hello home!</div>;
}
